import { lazy, Suspense } from 'react'
import { useFirstVisit } from '../hooks/useFirstVisit.js'

const Joyride = lazy(() => import('react-joyride'))

const STEPS = [
  {
    target: 'body',
    placement: 'center',
    title: 'The league',
    content: 'Quick walk through the page. Skip any time, replay from the menu.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="leaderboard"]',
    title: 'Leaderboard',
    content: 'Live. Reorders the moment new points land.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="dashboard"]',
    title: 'Your stuff',
    content: 'Points, weekly caps, streak, badges.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="log-cta"]',
    title: 'Log activity',
    content: 'Paste any LinkedIn URL. Stats get pulled automatically. Inbounds need a screenshot.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="caps"]',
    title: 'Weekly caps',
    content: '5 comments and 3 reposts per week. Posts and inbounds have no cap.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="badges"]',
    title: 'Badges',
    content: 'Bragging rights. Unlock automatically.',
    disableBeacon: true,
  },
]

export default function GuidedTour() {
  const { tourPending, finishTour } = useFirstVisit()

  if (!tourPending) return null

  return (
    <Suspense fallback={null}>
      <Joyride
        steps={STEPS}
        run={tourPending}
        continuous
        showProgress
        showSkipButton
        scrollToFirstStep
        styles={{
          options: {
            primaryColor: '#3076E2',
            textColor: '#272727',
            zIndex: 1000,
            arrowColor: '#ffffff',
            backgroundColor: '#ffffff',
          },
          tooltip: { borderRadius: 12, padding: 16 },
          buttonNext: { backgroundColor: '#3076E2', borderRadius: 8, padding: '8px 16px' },
          buttonBack: { color: '#272727' },
          buttonSkip: { color: '#B8B8B8' },
        }}
        callback={(data) => {
          if (data.status === 'finished' || data.status === 'skipped') finishTour()
        }}
      />
    </Suspense>
  )
}
